import BaseService from '../BaseService'
import axios from "axios";

class DashboardService extends BaseService {
    constructor() {
        super('/analytic');
    }

    getLastFeedback(duration, marketplace) {
        return axios.get(`${this.resource}/get-last-feedbacks?duration=${duration}&marketplace=${marketplace}`)
    }

    getHeaderCards(duration, marketplace) {
        return axios.get(`${this.resource}/get-top-cards?duration=${duration}&marketplace=${marketplace}`)
    }

    getMessageStatisticsChart(duration, marketplace) {
        return axios.get(`${this.resource}/get-message-statistic-chart?duration=${duration}&marketplace=${marketplace}`)
    }

    getBottomCards(duration, marketplace) {
        return axios.get(`${this.resource}/get-bottom-cards?duration=${duration}&marketplace=${marketplace}`)
    }

    getSalesChart(duration, marketplace) {
        return axios.get(`${this.resource}/get-sales-chart?duration=${duration}&marketplace=${marketplace}`)
    }
}

export default new DashboardService()
